import { useMutation } from 'react-query'
import useCacheKeys from '../../../hooks/use-cache-keys'
import useCache from '../../../hooks/use-cache'
import useApi from '../../../hooks/use-api'
import { get } from 'lodash'
import useCurrentUser from '../../../hooks/use-current-user'
import useToasts from '../../../hooks/use-toasts'
import useConfirmationDialog from '../../../hooks/use-confirmation-dialog'

const useCourseEnroll = ({
    courseId,
    onSuccess = () => {},
}) => {
    const { id: userId } = useCurrentUser()
    const cacheKeys = useCacheKeys()
    const { clearCache } = useCache({ key: cacheKeys.COURSES, onReload: onSuccess})
    const { api, url, endpoints } = useApi()
    const { toastSuccess } = useToasts({ successMessage: 'Experience Dropped!', onSuccess: clearCache })
    const { toastError } = useToasts()
    const [ mutate, {isLoading} ] = useMutation(
        () => api.delete(url(endpoints.userCourseEnrollment, { userId, courseId })),
        {
            onSuccess: toastSuccess,
            onError: toastError
        }
    )
    const { showConfirmation: drop } = useConfirmationDialog({
        onConfirm: mutate,
        title: 'Drop this experience?'
    })

    return {
        isLoading,
        drop
    }
}

export default useCourseEnroll